




































import { Vue, Component, Prop, Emit } from "@/shared/vuepack";
import CommonTabs from "@/employer/components/shared/CommonTabs.vue";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import Metric from "@/employer/components/metric/Metric.vue";
import { ProductPlanTab } from "@/employer/types";
import { Config } from "@/shared/config";

@Component({
  components: {
    CommonTabs,
    CommonTab,
    Metric,
  },
})
export default class MetricWithGraph extends Vue {
  @Prop() componentTitle!: string;
  @Prop() hasOptimize!: boolean;
  @Prop() employerCode!: string;
  @Prop() accessToken!: string;
  @Prop() metricBanners!: ProductPlanTab[];

  tableauUrl = Config.UserServicebaseUri;
}
